module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-Blog-1.570c15da.webp";